import { RouteConfig } from 'vue-router';

const PAGE_TITLE = '上游作文频道上线';

const route: RouteConfig = {
  path: '/20200421ZWXQD',
  name: 'ZWXQD',
  component: () => import('./Home.vue'),

  meta: {
    title: PAGE_TITLE,
  },
};

export default route;
